import { Skeleton, SkeletonWrapper } from './Skeleton';

export const TableCellLoader = ({
  width = 150,
  height = 8,
}: {
  width?: number;
  height?: number;
}) => (
  <SkeletonWrapper>
    <Skeleton style={{ width, height }} />
  </SkeletonWrapper>
);
